import { DNABox, DNADivider } from '@alucio/lux-ui';
import colors from '@alucio/lux-ui/src/theming/themes/alucio/colors';
import React from 'react';
import { FlatList, StyleSheet, View } from 'react-native';
import Skeleton from 'react-loading-skeleton';

const styles = StyleSheet.create({
  thumbnailSkeleton: {
    // width: 120,
    // height: 65,
    width: 160,
    height: 87,
    borderRadius: 4,
  },
  skeletonTextWrapper: {
    flexGrow: 1,
    marginLeft: 16,
  },
  skeletonMainText: {
    height: 14,
  },
  skeletonSubText: {
    height: 14,
    width: 'calc(100% - 40px)',
  },
  loadingWrapper: {
    display: 'flex',
    flexDirection: 'row',
    padding: 16,
  },
})

const SKELETON_COLOR_VARIANTS = {
  default: {
    baseColor: colors['color-gray-50'],
    highlightColor: colors['color-gray-100'],
  },
  dark: {
    baseColor: colors['color-gray-500'],
    highlightColor: colors['color-gray-400'],
  },
} as const;

interface Props {
  numberOfItems?: number
  variant?: 'default' | 'dark'
}

const ListSkeleton: React.FC<Props> = ({ numberOfItems = 3, variant = 'default' }) => {
  const { baseColor, highlightColor } = SKELETON_COLOR_VARIANTS[variant];

  const row = (
    <View style={[styles.loadingWrapper, variant === 'default' && { backgroundColor: 'white' }]}>
      <Skeleton
        baseColor={baseColor}
        highlightColor={highlightColor}
        borderRadius={4}
        style={styles.thumbnailSkeleton}
      />
      <DNABox spacing="sm" style={styles.skeletonTextWrapper} appearance="col">
        <Skeleton
          baseColor={baseColor}
          highlightColor={highlightColor}
          style={styles.skeletonMainText}
        />
        <Skeleton
          baseColor={baseColor}
          highlightColor={highlightColor}
          style={styles.skeletonSubText}
        />
      </DNABox>
    </View>
  )

  const Divider = <DNADivider colorMode={variant === 'dark' ? 'dark' : 'light'} />

  return (
    <FlatList
      data={Array.from(Array(numberOfItems).keys())}
      renderItem={(_) => row}
      keyExtractor={(_, index) => `${index}`}
      ItemSeparatorComponent={() => Divider}
    />
  )
}

export default ListSkeleton;
